<template>
  <div
    :id="id"
    class="subscription"
    :class="[isSelected && 'subscription--selected']"
    @click="$emit('click',{'id':$event.target.id})"
  >
    <v-icon
      class="subscription__icon"
      type="folder"
    />
    <span class="subscription__title">
      {{ title }}
      <span
        v-if="subtitle"
        class="subscription__subtitle"
      >{{ subtitle }}</span>
    </span>
    <div
      v-if="id"
      class="subscription__actions"
    >
      <v-icon-checkbox
        :id="'subscribe '+id"
        :checked="isSubscribe"
        class="subscription__checkbox"
        icon="bell"
        @click="subscribe(id,isSubscribe)"
      />
      <v-icon-checkbox
        v-if="isSubscribe"
        :id="'notify '+id"
        :checked="isNotify"
        class="subscription__checkbox"
        icon="email"
        @click="notify(id,isNotify)"
      />
    </div>
  </div>
</template>

<script>
  import Icon from "@/atoms/Icon";
  import IconCheckbox from "@/atoms/IconCheckbox";

  export default {
    components: {
      "v-icon": Icon,
      "v-icon-checkbox": IconCheckbox,
    },
    props: {
      id: {
        type: [Number, String],
        default: null
      },
      title: {
        type: String,
        default: null,
        required: true
      },
      subtitle: {
        type: String,
        default: null
      },
      isSubscribe: {
        type: Boolean,
        default: false
      },
      isNotify: {
        type: Boolean,
        default: false
      },
      isSelected: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      subscribe(id, isSubscribeAll) {
        this.$emit('subscribe', [id, isSubscribeAll]);
      },
      notify(id, isNotify) {
        this.$emit('notify', [id, isNotify]);
      }
    }
  };
</script>

<style lang="scss">
  @import "../../styles/shared/shared";

  .subscription {
    $this: &;
    display: flex;
    padding: $card-padding-y $card-padding-x;
    border-bottom: solid 1px $zircon;
    align-items: center;
    transition: .15s;
    &__icon {
      font-size: 1.5em;
      align-self: flex-start;
      margin-right: .5rem;
      color: $azure;
    }
    &__title {
      flex: 1;
      font-weight: bold;
      margin-right: 1rem;
      color: $tangaroa;
    }
    &__actions {
      display: flex;
    }
    &:hover {
      background-color: $zircon;
    }
    &--selected {
      &,
      &:hover {
        background-color: $azure;
        border-bottom-color: $azure;
        cursor: default;
      }
      #{$this}__checkbox label {
        color: rgba($white,.5);
      }
      #{$this}__checkbox input:checked + label,
      #{$this}__title,
      #{$this}__icon {
        color: $white;
      }
    }
  }
</style>
